<template>
    <div class="content-with-section-nav grid">
        <cmp-to-top></cmp-to-top>

        <transition name="trs-simple-appear">
            <cmp-course-detail-header v-if="routeData.course_detail_header"
                    :header="routeData.course_detail_header">
            </cmp-course-detail-header>
        </transition>

        <div class="grid--container">
            <div class="grid--row">
                <div class="grid--col content-with-section-nav--aside">
                    <cmp-section-nav></cmp-section-nav>
                </div>
                <div class="grid--col content-with-section-nav--main">
                    <cmp-breadcrumbs :tree="routeData.breadcrumbs"></cmp-breadcrumbs>
                    <cmp-main :container="containers.main"></cmp-main>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapActions } from 'vuex';
    import routeMixin from 'vue/mixins/route';

    export default {
        mixins: [routeMixin],
        methods: {
            ...mapActions(['flushSections']),
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?08f6ce58